// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9593d879","111":"74cfd8aa","453":"aa2c8197","510":"e7988934","589":"da7b0edc","606":"7943a87e","637":"17b7b567","641":"566fdc19","710":"1e538d02","833":"aa84f602","953":"799260f9","991":"2c4cf003"}[chunkId] + ".chunk.js";
};